<template>
  <el-dialog
    :visible="value"
    width="520px"
    custom-class="sign-in-icloud-dialog"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="handleClose"
  >
    <div class="sign-in-icloud-body">
      <div class="sign-in-icloud-close-x" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>
      <div class="sign-in-icloud-title">
        {{ $t("signInIcloud.title") }}
      </div>

      <div class="sign-in-icloud-steps">
        <div class="sign-in-icloud-step" v-for="(step, index) in steps" :key="index">
          <div class="sign-in-icloud-step-num">{{ index + 1 }}</div>
          <div class="sign-in-icloud-step-text" v-html="$t(step)"></div>
        </div>
      </div>

      <div class="sign-in-icloud-tip">
        {{ $t("signInIcloud.tip") }}
      </div>

      <div class="sign-in-icloud-close-btn" @click="handleClose">
        {{ $t("signInIcloud.close") }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SignInToICloudDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      steps: [
        "signInIcloud.step1",
        "signInIcloud.step2",
        "signInIcloud.step3",
        "signInIcloud.step4",
      ],
    };
  },
  methods: {
    handleClose() {
      this.$emit("input", false);
    },
  },
};
</script>

<style>
.sign-in-icloud-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.sign-in-icloud-dialog .el-dialog__header {
  display: none;
}

.sign-in-icloud-dialog .el-dialog__body {
  color: #000927;
  padding: 0 !important;
}

.sign-in-icloud-body {
  position: relative;
  padding: 30px 26px 26px;
}

.sign-in-icloud-close-x {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
  font-size: 20px;
  z-index: 1;
}

.sign-in-icloud-close-x:hover {
  color: #000927;
}

.sign-in-icloud-title {
  font-family: Noto Sans, sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 28px;
}

.sign-in-icloud-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sign-in-icloud-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.sign-in-icloud-step-num {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #00eec3;
  color: #000927;
  font-family: Noto Sans, sans-serif;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.sign-in-icloud-step-text {
  font-family: Noto Sans, sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: #45484d;
  padding-top: 2px;
}

.sign-in-icloud-step-text b {
  font-weight: 700;
  color: #000927;
}

.sign-in-icloud-tip {
  margin-top: 20px;
  font-family: Noto Sans, sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: #808080;
}

.sign-in-icloud-close-btn {
  margin-top: 24px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 25px;
  background: #00eec3;
  color: #000927;
  font-family: Noto Sans, sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 6px rgb(8 145 120 / 50%);
  transition: opacity 0.2s;
}

.sign-in-icloud-close-btn:hover {
  opacity: 0.9;
}

@media screen and (max-width: 600px) {
  .sign-in-icloud-dialog {
    margin-top: 10vh !important;
    max-width: 400px;
    width: calc(100% - 40px) !important;
  }

  .sign-in-icloud-body {
    padding: 24px 22px 22px;
  }

  .sign-in-icloud-title {
    font-size: 18px;
    line-height: 27px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignInToICloudDialog.vue